import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { BottomModal } from '../../components/shared/BottomModal';
import { useSubscription } from '../../hooks/useSubscription';
import config from '../../config';

const pluralPersons = (n) => {
  const mod10 = n % 10;
  const mod100 = n % 100;
  if (mod10 === 1 && mod100 !== 11) return 'человек';
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) return 'человека';
  return 'человек';
};

// «Кто пойдёт»: без подписки — превью с пейволом, с подпиской — полный список
export function JoinsSheet({ event, isOpen, onClose }) {
  const navigate = useNavigate();
  const { isActiveSubscription } = useSubscription();
  const subscribed = isActiveSubscription === true;

  // С подпиской «Кто пойдёт» открывает отдельную страницу со списком участников
  useEffect(() => {
    if (!isOpen || !subscribed || !event?._id) return;

    onClose();
    navigate(config.ROUTES.EVENTS.PARTICIPANTS(event._id));
  }, [isOpen, subscribed, event?._id, navigate, onClose]);

  const joins = event?.joins || 0;
  const avatars = event?.joinUsers || [];
  const extraCount = Math.max(0, joins - Math.min(avatars.length, 3));
  const previewAvatars = [...avatars.slice(0, 3)];
  while (previewAvatars.length < Math.min(3, Math.max(joins, 1))) {
    previewAvatars.push(null);
  }

  return (
    <BottomModal isOpen={isOpen} onClose={onClose}>
      {!subscribed ? (
        /* Превью без подписки: превью участников + пейвол */
        <div className="px-5 pb-8 flex flex-col items-center gap-4">
          <p className="text-white text-[19px] font-semibold font-raleway text-center leading-snug">
            Мероприятие — отличный повод для знакомств
          </p>
          <p className="text-white/80 text-[15px] font-raleway text-center">
            {joins > 0
              ? `Еще ${joins} ${pluralPersons(joins)} ${joins === 1 ? 'хочет' : 'хотят'} пойти на него вместе с тобой`
              : 'Пока никто не отметился — будь первым!'}
          </p>

          <div className="flex items-center pt-1">
            {previewAvatars.slice(0, 3).map((photo, i) => (
              <img
                key={i}
                src={photo || '/mock/stream_chat_user_avatar.png'}
                alt=""
                className={`w-[48px] h-[48px] rounded-full object-cover -ml-2 first:ml-0 ${
                  i === (event?.myJoinIndex ?? -1) ? '' : 'blur-[6px] select-none'
                }`}
              />
            ))}
            {extraCount > 0 && <span className="ml-2 text-[18px] font-bold text-white">+{extraCount}</span>}
          </div>

          <button
            onClick={() => navigate(config.ROUTES.PAYWALL)}
            className="w-full h-[56px] rounded-[400px] bg-[#A1F69E] text-[#010D0D] text-[16px] font-semibold font-raleway active:bg-[#7DD279]"
          >
            Посмотреть кто идёт
          </button>
        </div>
      ) : null}
    </BottomModal>
  );
}
